// OIB validation using Modul 11,10 algorithm
export const validateOIB = (oib, currentLanguage = 'en') => {
  if (!oib) return { isValid: false, message: 'OIB je obavezan' };

  const oibRegex = /^\d{11}$/;
  if (!oibRegex.test(oib)) {
    return {
      isValid: false,
      message: currentLanguage === 'hr' ? 'OIB mora sadržavati točno 11 znamenki' : 'OIB must contain exactly 11 digits'
    };
  }

  let a = 10;

  for (let i = 0; i < 10; i++) {
    a = (a + parseInt(oib[i], 10)) % 10;
    if (a === 0) a = 10;
    a = (a * 2) % 11;
  }

  let checkDigit = 11 - a;
  if (checkDigit === 10) checkDigit = 0;

  const lastDigit = parseInt(oib[10], 10);
  if (checkDigit !== lastDigit) {
    return {
      isValid: false,
      message: currentLanguage === 'hr' ? 'Neispravan OIB - kontrolni broj se ne podudara' : 'Invalid OIB - check digit does not match'
    };
  }

  return { isValid: true, message: '' };
};
